export default "__VITE_ASSET__Cb1_vSNO__"